import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TSyainInfoGetRes,
  TSyainListGetReq,
  TSyainQRHashListGetRes,
  TSyainRegisterPostReq,
  TSyainUpdatePutReq,
} from "./TSyain"

/**
 * 社員マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class SyainService
 * @extends {ConnectApi}
 */
export default class SyainService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TSyainListGetReq} params
   * @param {(param: TApiResponse<TSyainInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyainInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  getList = async (params: TSyainListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainInfoGetRes[]>> =
        await this.getInner(`/master/syain`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TSyainListGetReq} params
   * @param {(param: TApiResponse<TSyainInfoGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TSyainInfoGetRes[]>) => any} reject
   * @memberof MenuService
   */
  get = async (id: string | number) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainInfoGetRes>> =
        await this.getInner(`master/syain/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  getByCardId = async (cardId: string) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainInfoGetRes>> =
        await this.getInner(`master/syain/get/cardid/${cardId}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  upsertQRHash = async (id: number) => {
    try {
      const res: AxiosResponse<TApiResponse<string>> = await this.getInner(
        `master/syain/${id}/create/qr`
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  getQRHashList = async (idList: number[]) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyainQRHashListGetRes>> =
        await this.postInner(`master/syain/get/qr/list`, { 社員IDList: idList })
      return res.data
    } catch (err) {
      throw err
    }
  }

  printQRHashList = async (idList: number[]) => {
    try {
      const res: AxiosResponse<Blob> = await this.postInner(
        `/report/CreateReport/G050301`,
        { 運行管理者IDList: idList }
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体登録
   *
   * @param {TKyotenPostReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  post = async (data: TSyainRegisterPostReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `master/syain`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TSyainUpdatePutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: string, data: TSyainUpdatePutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `master/syain/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
